// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__R2QHB","title":"card_title__2shIW","inActive":"card_inActive__2xRHt"};